import React from "react"

export const useClickOutside = (ref, callback) => {
  const handleClick = e => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback()
    }
  }

  React.useEffect(() => {
    document.addEventListener("mousedown", handleClick)

    return () => {
      document.removeEventListener("mousedown", handleClick)
    }
  }, [callback, ref])
}

export const useClickOutsideBasedOnId = (ref, callback) => {
  const handleClick = e => {
    if (ref.current && ref.current.id !== e.target.id) {
      callback()
    }
  }

  React.useEffect(() => {
    document.addEventListener("click", handleClick)

    return () => {
      document.removeEventListener("click", handleClick)
    }
  })
}

export const useClickOutsideParentAndChild = (ref, handler) => {
  React.useEffect(() => {
    const trigger = e => {
      if (ref.current && e.target.isConnected && !ref.current.contains(e.target)) handler()
    }

    document.addEventListener("click", trigger)

    return () => document.removeEventListener("click", trigger)
  }, [handler, ref])
}

export const useClickOutsideParentAndChildWithKeydown = (ref, handler) => {
  React.useEffect(() => {
    const trigger = e => {
      if (
        (e?.type === "click" && e?.target?.isConnected && !ref?.current?.contains(e?.target)) ||
        (e?.type === "keydown" && (e?.key === "Enter" || e?.key === "Tab"))
      ) {
        handler()
      }
    }

    document.addEventListener("click", trigger)
    document.addEventListener("keydown", trigger)

    return () => {
      document.removeEventListener("click", trigger)
      document.removeEventListener("keydown", trigger)
    }
  }, [handler, ref])
}
